'use client'
import { FadeIn, FadeInStagger } from '@/components/ui/animation/faideIn'
import {
  SearchIcon,
  SearchIconWhite,
  SvgArrowUpRight,
  SvgDate,
  SvgLocation,
} from '@/components/ui/icons'
import apolloClient from '@/lib/apollo/apollo-client'
import { EVENTSPOSTTYPE } from '@/lib/apollo/queries'
import parser from 'html-react-parser'
import moment from 'moment'
import { default as Link, default as NextLink } from 'next/link'
import { cache, useEffect, useState } from 'react'
import CTANewEvents from './CTANewEvents'
import { Skeleton } from './Skeleton'
import LocationDropDown from './locationDropdown'
import PaginatedTable from './paginate-events'
// import { getEvents } from '@/lib/utils/luma-events'

const EventHero = () => {
  const [events, setEvents] = useState([])
  const [allEvents, setAllEvents] = useState([])
  const [filteredVal, setFilteredVals] = useState([])
  const [selectedLocation, setSelectedLocation] = useState('Location')
  const [isLoading, setIsLoading] = useState(true)
  const [activeVal, setActive] = useState('Date')

  const getData = cache(async () => {
    setIsLoading(true)
    try {
      // const eventsData = await getEvents()
      // console.log('eventsData', eventsData)
      const useCasesOptions = await apolloClient.query({
        query: EVENTSPOSTTYPE,
      })
      // console.log('useCasesOptions', useCasesOptions)
      const useCasesData = useCasesOptions.data.events?.nodes
      // console.log('useCasesData', useCasesData)

      const getFirstPTagContent = (htmlContent) => {
        // Ensure that htmlContent is a string
        if (typeof htmlContent !== 'string') {
          console.error('htmlContent is not a string:', htmlContent)
          return null
        }

        try {
          // Parse the HTML content
          const parsedContent = parser(htmlContent)
          // console.log('parsedContent', parsedContent)

          // Find the first <p> tag
          const firstPTag = parsedContent.find((element) => {
            return (
              element.props && element.props.children && element.type === 'p'
            )
          })

          // Return the content of the first <p> tag or null if not found
          return firstPTag ? parser(firstPTag.props.children) : null
        } catch (error) {
          console.error('Error parsing HTML content:', error)
          return null
        }
      }

      const mappedArray = useCasesData.map((val) => {
        // console.log(
        //   'val',
        //   val,
        //   val.eventsPostTypes,
        //   val.eventsPostTypes?.eventDate,
        // )
        // Safe checks for featuredImage and event properties
        const img =
          val.featuredImage && val.featuredImage.node
            ? val.featuredImage.node.sourceUrl
            : ''
        const eventCity = val.eventsPostTypes?.eventCity || 'Unknown City'
        const eventCountry =
          val.eventsPostTypes?.eventCountry || 'Unknown Country'
        const eventDate = val.eventsPostTypes?.eventDate || 'Unknown Date'
        const eventUrl = val.eventsPostTypes?.eventUrl || '#'

        const firstPTagContent = getFirstPTagContent(val.content) || ''

        return {
          img: img,
          location: `${eventCity}, ${eventCountry}`,
          date: eventDate,
          heading: val.title,
          desc: firstPTagContent,
          slug: eventUrl,
        }
      })
      const currentDate = new Date()
      currentDate.setHours(0, 0, 0, 0)
      let sortedEvents = [...mappedArray].filter((event) => {
        // const eventDate = parseDate(event.date.split(' - ')[0])
        const eventDate = new Date(event.date)
        // console.log('fetch events', event.date, eventDate)
        return eventDate < currentDate
      })
      // console.log(' to fetch events', mappedArray, sortedEvents)
      setEvents(mappedArray)
      setAllEvents(sortedEvents)
      setFilteredVals(mappedArray)
    } catch (error) {
      console.log('Failed to fetch events', error)
    }
    setIsLoading(false)
  })
  const parseDate = (dateString) => {
    const monthNames = {
      January: 0,
      February: 1,
      March: 2,
      April: 3,
      May: 4,
      June: 5,
      July: 6,
      August: 7,
      September: 8,
      October: 9,
      November: 10,
      December: 11,
    }
    const parts = dateString.match(/(\w+) (\d+), (\d+)/)
    if (!parts) return new Date(NaN)
    const [, monthName, day, year] = parts
    const monthIndex = monthNames[monthName]
    // console.log(monthIndex, 'monthIndex');
    return new Date(year, monthIndex, parseInt(day))
  }
  useEffect(() => {
    getData()
  }, [])
  // comments
  const decodeHtmlEntity = (str) => {
    const textArea = document.createElement('textarea')
    textArea.innerHTML = str
    return textArea.value
  }

  const handleChange = (e) => {
    const searchTerm = decodeHtmlEntity(e.target.value).toLowerCase()
    const currentDate = new Date()
    currentDate.setHours(0, 0, 0, 0)
    const filteredEvents = events.filter((event) => {
      const eventDate = new Date(event.date)
      const eventLocation = decodeHtmlEntity(event.location).toLowerCase()
      const eventHeading = decodeHtmlEntity(event.heading).toLowerCase()
      const eventDesc = decodeHtmlEntity(event.desc).toLowerCase()

      const matchesLocation =
        selectedLocation === 'Location' ||
        eventLocation.includes(selectedLocation.toLowerCase())
      const matchesSearchTerm =
        searchTerm === '' ||
        eventLocation.includes(searchTerm) ||
        eventHeading.includes(searchTerm) ||
        eventDesc.includes(searchTerm)
      const isFutureEvent = eventDate >= currentDate

      return matchesLocation && matchesSearchTerm && isFutureEvent
    })

    setFilteredVals(filteredEvents)
  }
  useEffect(() => {
    handleChange({ target: { value: '' } })
  }, [selectedLocation, events])
  function compareDates(a, b) {
    // Convert dates to Date objects for comparison
    const dateA = new Date(a.date)
    const dateB = new Date(b.date)

    // Compare dates
    if (dateA < dateB) return -1
    if (dateA > dateB) return 1
    return 0
  }
  return (
    <div className="flex flex-col align-center gap-4 w-screen ">
      <div className=" relative isolate overflow-hidden z-0">
        <img
          alt="bg-image"
          className="absolute hidden lg:flex lg:top-[-250px] w-full -z-10"
          src="/Background.png"
        />
        <div
          className="absolute left-1/2 right-0 top-0 -z-10 -ml-24 transform-gpu overflow-hidden blur-3xl lg:ml-24 xl:ml-48"
          aria-hidden="true"
        ></div>
        <div className="overflow-hidden mt-[-170px]">
          <FadeInStagger
            faster
            className="mx-auto max-w-7xl px-6 pb-32 pt-36 sm:pt-60 lg:px-8 lg:pt-32"
          >
            <div className="flex justify-center mt-[120px]">
              <FadeIn className="bg-white bg-opacity-5 flex gap-2 px-0.5  rounded-full py-1  border border-[#424242]">
                <Link
                  className="tw-[76px] h-6 px-2.5 py-0.5 text-white bg-white bg-opacity-10 rounded-2xl justify-start items-center inline-flex font-medium"
                  href="/"
                >
                  AI Forge
                </Link>
                <div className="flex flex-row items-center">
                  <button className="text-xs sm:text-sm leading-tight  text-white pr-3 cursor-default font-medium">
                    Community
                  </button>
                </div>
              </FadeIn>
            </div>
            <FadeIn className="mt-3 justify-center flex ">
              <h1
                className="text-7xl lg:text-[72px] font-bold lg:leading-[90px] text-center text-white
              lg:w-[952px]  "
              >
                Discover Upcoming Events
              </h1>
            </FadeIn>
            <FadeIn
              className="text-[#98A2B3] text-[20px] leading-[30px] font-normal text-center mt-8 max-w-3xl mx-auto
            lg:w-[768px] "
            >
              Embark on an Odyssey of Opportunities: Events That Spark
              Possibilities.
            </FadeIn>
            <FadeIn className="flex justify-center gap-4 mt-0"></FadeIn>
          </FadeInStagger>
        </div>

        <div className="bg-gradient-to-t from-[#000] ">
          <div className="mx-auto max-w-7xl px-5 ">
            {/* <div className="hidden flex-col flex gap-4 lg:flex-row justify-between lg:ml-[14px]">
              <FadeInStagger faster>
                <div className="flex justify-between gap-3 p-3 lg:p-0">
                  <div className="lg:w-[435px] w-full h-[60px] p-[18px] text-white bg-white bg-opacity-10 rounded-xl border border-neutral-400 backdrop-blur-[10px] justify-start items-center gap-3 inline-flex placeholder:text-gray-600">
                    <SearchIcon className="w-6 h-6" />
                    <input
                      className="w-full text-white  placeholder:text-gray-600 border-none ring-transparent"
                      placeholder="Search"
                      onChange={handleChange}
                      style={{ background: 'none' }}
                    />
                  </div>
                  <button className="lg:w-[60px] w-[60px] h-[60px] relative bg-blue-600 rounded-xl flex-col justify-center items-center  inline-flex">
                    {' '}
                    <SearchIconWhite className="w-6 h-6 text-white relative" />
                  </button>
                </div>
              </FadeInStagger>

              <FadeInStagger faster>
                <LocationDropDown
                  selectedLocation={selectedLocation}
                  setSelectedLocation={setSelectedLocation}
                />
              </FadeInStagger>
            </div> */}
            <FadeInStagger
              faster
              className=" pt-0 p-10 xl:p-0 xl:pt-0  lg:grid xl:grid-cols-2  gap-20 "
            >
              {isLoading ? (
                <Skeleton />
              ) : (
                filteredVal.length !== 0 &&
                filteredVal.sort(compareDates)?.map((event, indx) => (
                  <FadeInStagger faster key={indx}>
                    <div className="h-full rounded-xl justify-center items-start inline-flex w-full">
                      <div className="flex flex-col gap-6 mb-4 lg:mb-0">
                        <NextLink target="_blank" href={`${event?.slug}`}>
                          <img
                            height={1000}
                            width={1000}
                            className=" lg:w-[570px] rounded-xl object-cover "
                            // className=" lg:w-[570px]  h-64 rounded-xl aspect-video object-cover "
                            src={event?.img}
                            alt="image"
                          />
                        </NextLink>

                        <div className="flex justify-between flex-col gap-3 md:flex-row lg:gap-0  ">
                          <p className="h-[19px] text-[#98A2B3] text-[16px] font-medium tracking-tight flex gap-2">
                            <SvgLocation stroke={'#98A2B3'} />
                            {event?.location}
                          </p>
                          <p className="h-[19px] text-[#98A2B3] text-[16px] font-medium tracking-tight flex gap-2 items-center">
                            <SvgDate />
                            {moment(event.date).format('MMMM D, YYYY')}
                          </p>
                        </div>
                        <div className="flex flex-col gap-2.5">
                          <NextLink
                            target="_blank"
                            href={`${event?.slug}`}
                            className="text-white text-[22px] leading-[26.63px] font-bold  capitalize"
                          >
                            {event?.heading}
                          </NextLink>
                          <p className="lg:w-[564px] text-[#98A2B3] text-sm font-normal capitalize leading-[22px] tracking-tight text-clip ">
                            {' '}
                            {event?.desc}
                          </p>
                        </div>
                        <div className="flex justify-between">
                          <NextLink
                            target="_blank"
                            href={`${event?.slug}`}
                            className=" flex  items-center gap-3 text-[#155EEF] text-lg font-semibold leading-7"
                          >
                            More Info <SvgArrowUpRight />
                          </NextLink>
                        </div>
                      </div>
                    </div>
                  </FadeInStagger>
                ))
              )}
            </FadeInStagger>
          </div>
          {filteredVal && filteredVal.length === 0 && (
            <div className="text-white text-center ">No events found.</div>
          )}
          <div className="mx-auto max-w-7xl mt-20 gap-16 flex flex-col">
            <div className="flex flex-col gap-2">
              <h1 className="text-center text-[#155EEF] text-base font-semibold leading-normal">
                Events in Retrospect
              </h1>
              <p className="text-center text-white text-[36px] font-semibold leading-[44px]">
                Past Event
              </p>
            </div>
            {/* <div className="flex flex-col  lg:px-5 justify-center ">
              <div className="flex items-start w-full md:ml-4"></div>
            </div> */}
            {allEvents && allEvents.length === 0 && (
              <div className="text-white text-center ">No events found.</div>
            )}

            {allEvents?.length > 0 && (
              <div className="flex flex-col items-center justify-center w-full">
                <PaginatedTable
                  itemsPerPage={10}
                  pastEventsList={allEvents}
                  activeVal={activeVal}
                  setActive={setActive}
                />
              </div>
            )}
            <CTANewEvents />
          </div>
        </div>
      </div>
    </div>
  )
}

export default EventHero
